import { makeVar, useReactiveVar } from '@apollo/client';

export const isOnlineVar = makeVar<boolean>(navigator.onLine);

export const useNetworkStatus = () => {
  const isOnline = useReactiveVar(isOnlineVar);

  return { isOnline };
};
